import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import createEntityRecord from '../helpers/services/create-entity-record';

const useCreateEntityRecord = entitySchema => {
  const client = useApolloClient();

  return useCallback(
    input => createEntityRecord(client, entitySchema, input),
    [client, entitySchema]
  );
};

export default useCreateEntityRecord;
